/**
 * Formats an address object into a single display line.
 *
 * Args:
 *   address (AddressDetails | undefined): Address details to format. Optional.
 *
 * Returns:
 *   string: Comma/space separated address components, or an empty string when no address is provided.
 *
 * Notes:
 *   Assumes address fields are already sanitized; does not perform trimming beyond assembly.
 *   TODO: Confirm whether international formatting rules are needed.
 */
export const formatAddressLine = (address?: AddressDetails) => {
  if (!address) return "";
  const unit = address.unit_number ? `${address.unit_number}, ` : "";
  const streetNumber = address.street_number ? `${address.street_number}, ` : "";
  const streetName = address.street_name ? `${address.street_name}, ` : "";
  const suburb = address.suburb ?? "";
  const state = address.state ?? "";
  const postcode = address.postcode ?? "";
  return `${unit}${streetNumber}${streetName}${suburb} ${state} ${postcode}`.trim();
};
